import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class ListRecordsDownloadRequestsService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
  ) { }

  listRecordsDownloadRequests(sectionId: string) {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    headers = headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    //
    let params = new HttpParams();

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/RecordsDownloadRequests`, { headers: headers, params: params });

    }

}
